<template>
<div v-loading="exportLoading" element-loading-text="正在调整阀值">
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form>
            <el-form-item>
                <el-button type="primary" @click="exportTable()" style="margin-right:20px;">批量调整阀值</el-button>
                <el-input-number v-model="currmonthflowlimit" :min="0"></el-input-number>
                <span style="color:red;margin-left:5px;"><i class="el-icon-warning-outline"></i>流量阀值(MB)</span>
            </el-form-item>
        </el-form>
    </el-col>
    <el-input type="textarea" :rows="20" :placeholder="placeholder" v-model="textarea" class="textexport">
    </el-input>
</div>
</template>

<script>
import {
    bathAddFlow
} from '../../api/api'
export default {
    data() {
        return {
            textarea: '',
            currmonthflowlimit:'',
            exportLoading: false,
            placeholder : "请粘贴要调整阀值的卡号列表(每一条一行)"
        }
    },
    methods: {
        exportTable() {

            if (this.textarea.trim() == "") {
                this.$message({
                    message: '卡信息不能为空',
                    type: 'error'
                });
            } else {
                let para = {
                    cardinfo: this.textarea.trim(),
                    currmonthflowlimit : this.currmonthflowlimit
                }
                this.exportLoading = true;
                bathAddFlow(para).then((res) => {
                    if(res.code==0){
                        this.exportLoading=false;
                        this.textarea=res.msg;
                    }else{
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        });
                        this.exportLoading=false;
                    }
                });
            }
        }
    }

}
</script>  

<style>
.textexport {
    margin-top: 10px;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// batch_flow.vue?3aa72168